export const OFFER_STEPS = {
  FIRST_STEP: '1',
  SECOND_STEP: '2',
  THIRD_STEP: '3',
};
